import script from "./Top.vue?vue&type=script&setup=true&lang=js"
export * from "./Top.vue?vue&type=script&setup=true&lang=js"

import "./Top.vue?vue&type=style&index=0&id=0b082034&scoped=true&lang=css"
script.__scopeId = "data-v-0b082034"

export default script